<template>
    <div class="layer">
        <div class="wrap">
            <Header></Header>
            <div class="content_layer">
                <div class="content">
                    <div id="board_layer">
                        <!-- <Menu></Menu> -->
                        <div class="board_search_v2 board_search_wrap" v-if="state.tabmenu !== 1">
                            <div class="bo_sch_content">
                                <div class="sch_box">
                                    <div class="bo_sch_content">
                                        <span class="bo_sch_tit">기간</span>
                                        <DateRange :date="state.date" @changeDate="selectDate"></DateRange>
                                    </div>
                                    <div class="sch_btns">
                                        <button type="button" class="sch_btn" @click="getData()">검색하기</button>
                                        <button type="button" class="sch_re_btn" @click="resetFilter()">
                                            <img src="@/assets/board/re_btn.png" alt="" />
                                            초기화
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 통계 탭 메뉴 -->
                        <div class="board_top statis" :class="{ no_filter: state.tabmenu === 1 }">
                            <div class="board_cate_btns">
                                <button
                                    v-for="item in tabMenu"
                                    :class="{ active: state.tabmenu === item.idx }"
                                    @click="selectTab(item.idx)"
                                >
                                    {{ item.name }}
                                </button>
                            </div>
                        </div>
                        <div class="board_graph_wrap">
                            <TotalChart v-if="state.tabmenu === 1" :loading="state.isLoading" :chartData="chartData.total"></TotalChart>
                            <SearchChart
                                v-else-if="state.tabmenu === 2"
                                :loading="state.isLoading"
                                :chartData="chartData.performance"
                            ></SearchChart>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" config>
    import {
        Header,
        Menu,
        reactive,
        onMounted,
        globalStore,
        Chart,
        DateRange,
        apiService,
        watch,
        numberFormat,
        Spinner,
        dateFormat,
    } from "@/BaseComponent";
    import TotalChart from "./totalChart.vue";
    import SearchChart from "./searchChart.vue";

    export default {
        props: [],
        components: {
            Header,
            Menu,
            Chart,
            DateRange,
            Spinner,
            TotalChart,
            SearchChart,
        },

        setup() {
            const global = globalStore();
            const state = reactive({
                date: [] as Array<Date>,
                tabmenu: 1 as number,
                showData: 0 as number,

                currentPage: 1 as number,
                totalLength: 0 as number,
                perPage: 10 as number,

                isLoading: false as boolean,
            });

            const chartData = reactive({
                total: null as any,
                performance: null as any,
            });

            const tabMenu = [
                { idx: 1, name: "전체현황" },
                { idx: 2, name: "탐지결과" },
            ];

            onMounted(() => {
                global.setSelectMenu(7);
                if (global.searchDate.length === 0) {
                    const startDate = new Date(new Date().setDate(new Date().getDate() - 7));
                    const endDate = new Date();
                    state.date = [startDate, endDate];
                } else {
                    state.date = global.searchDate;
                }
                getData();
            });

            watch(
                () => global.searchDate,
                (newDate) => {
                    state.date = newDate;
                },
            );

            const resetFilter = () => {
                const startDate = new Date(new Date().setDate(new Date().getDate() - 7));
                const endDate = new Date();
                state.date = [startDate, endDate];
                global.setSearchDate(state.date);
                getData();
            };

            const getData = async () => {
                if (state.tabmenu === 1) getTotalData();
                else if (state.tabmenu === 2) getPerformanceData();
            };

            const getTotalData = async () => {
                const param = {};
                const res = await apiService.ai.getGraph(param);
                if (res.returnCode === 0) {
                    chartData.total = res;
                } else chartData.total = [];
            };

            const getPerformanceData = async () => {
                const param = {
                    startDate: dateFormat(new Date(state.date[0])),
                    endDate: dateFormat(new Date(state.date[1])),
                };
                const res = await apiService.ai.getResultGraph(param);
                if (res.returnCode === 0) {
                    chartData.performance = res;
                } else chartData.performance = [];
            };

            const selectDate = (date: any) => {
                state.date = date;
                global.setSearchDate(date);
            };

            const selectTab = (idx: number) => {
                state.tabmenu = idx;
                state.currentPage = 1;
                getData();
            };

            const selectPage = (page: number) => {
                state.currentPage = page;
                getData();
            };

            return {
                state,
                chartData,
                tabMenu,
                resetFilter,
                getData,
                selectDate,
                numberFormat,
                selectTab,
                selectPage,
            };
        },
    };
</script>

<style scoped>
    .dp__input {
        width: 15%;
    }
    .board_graph_top {
        display: flex;
        gap: 20px;
    }
    .board_btn.board_ico_btn.active {
        background-color: var(--lightBlue) !important;
        color: #ffffff !important;
    }
    #board_layer .sch_box {
        height: 45px;
    }

    #board_layer table.board_table thead th {
        background-color: #012f5c;
        color: #ffffff;
        font-size: 16px;
        font-weight: 700;
        line-height: 1.2;

        border: 1px solid #dfdfdf;
        height: auto;
    }

    #board_layer table.board_table tbody tr td {
        background-color: #ffffff;
        color: #012f5c;
        font-size: 16px;
        font-weight: 700;

        border: 1px solid #dfdfdf;
        height: auto;
    }
    .board_graph_list {
        padding-top: 20px;
    }

    #board_layer .board_cate_btns button:disabled {
        background-color: #c7c7c7;
        color: white;
        cursor: no-drop;
    }

    .no_filter {
        margin-top: 40px;
    }
</style>
